var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 52.6228,
    height: 52.6228,
    rx: 8,
    fill: "#F5F7F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4582_46104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.44 29.0598V27.3948C23.44 26.7498 22.96 26.4348 22.375 26.6898L14.86 29.9298C13.675 30.4398 12.715 29.8098 12.715 28.5348V26.5548C12.715 25.5348 13.48 24.3498 14.425 23.9598L22.975 20.2848C23.215 20.1648 23.425 19.8498 23.425 19.5798V14.9898C23.425 13.5498 24.49 11.8248 25.765 11.1648C26.215 10.9398 26.755 10.9398 27.205 11.1648C28.495 11.8248 29.56 13.5348 29.56 14.9748V19.5648C29.56 19.8348 29.77 20.1498 30.01 20.2698L31.57 20.9298L23.44 29.0598Z",
    fill: "#1C9FDA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M40.285 26.5547V28.5347C40.285 29.8097 39.325 30.4397 38.14 29.9297L30.625 26.6897C30.025 26.4497 29.56 26.7497 29.56 27.3947V31.7597C29.56 32.1047 29.755 32.5997 30.01 32.8397L33.49 36.3347C33.85 36.6947 34.015 37.4147 33.85 37.9097L33.175 39.9497C32.875 40.8347 31.87 41.2397 31.045 40.8347L27.475 37.8347C26.935 37.3697 26.05 37.3697 25.51 37.8347L21.94 40.8347C21.115 41.2547 20.11 40.8347 19.84 39.9497L19.165 37.9097C19 37.3997 19.165 36.6947 19.525 36.3347L23.005 32.8397C23.245 32.5997 23.44 32.1047 23.44 31.7597V29.0597L31.57 20.9297L38.575 23.9447C39.52 24.3497 40.285 25.5347 40.285 26.5547Z",
    fill: "#1C9FDA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4582_46104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(8.5 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.8f5fad182af26c9575b34cc0330a5124.svg";
export { ForwardRef as ReactComponent };